import React, { FC } from 'react';
import { ReactComponent as Logout } from '../../../assets/MainMenu/Logout.svg';

export const LogoutIcon: FC = () => <Logout />;
